module.exports = __webpack_public_path__ + "img/Cas9variants_C.050a5a1c.svg";